import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import App from "./App";
import PageNotFound from "./Components/Utils/PageNotFound";
import PrivateRoute from "./Services/PrivateRouter";
import { GetDashboardRole } from "./Components/Utils/roles";
import { ClientManagementRoutes, CollectionAndReturnRoutes, ContactsRoutes, DashboardRoutes, EmailRoutes, FormRoutes, InspectionRoutes, ReportRoutes, TaskRoutes } from "./Routes";
import TestingAndCommisioningRoutes from "./Routes/Testing&Commisioning.routes";
import TicketsRoutes from "./Routes/Tickets.routes";
import SettingRoutes from "./Routes/SettingRoutes";
import Auth from "./Views/Main/MainAuth";
import AnotherLogin from "./Views/Web/Auth/login/AnotherIndex";
import ChangePassword from "./Views/Web/Auth/login/changePassword";
import InvoiceRoutes from "./Routes/invoice.routes";

function Mainroutes() {
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === ""  ||
      location.pathname === "main-page"
    ) {
      const hasMutipleOffice = localStorage.getItem("hasmutiple")?JSON.parse(localStorage.getItem("hasmutiple")):false;
        window.location.replace(
        hasMutipleOffice == true ? "/main-page/dashboard" 
        : GetDashboardRole("")
        ? `/dashboard`
        : GetDashboardRole("sales")
        ? `/dashboard/sales`
        : GetDashboardRole("procurement")
        ? `/dashboard/procurement`
        : GetDashboardRole("store")
        ? `/dashboard/stores`
        : `/dashboard`
      );
    }
    if (location.pathname === "/auth") {
      window.location.replace("/auth/login");
    }
   
  }, [location]);



  return (
    <Routes>
    <Route
      path="/"
      element={
        <PrivateRoute>
          <App/>
        </PrivateRoute>
      }
    >
        {DashboardRoutes()}
          {CollectionAndReturnRoutes()}
          {ClientManagementRoutes()}
          {ContactsRoutes()}
          {EmailRoutes()}
          {FormRoutes()}
          {InspectionRoutes()}
          {ReportRoutes()}
          {TaskRoutes()}
          {TestingAndCommisioningRoutes()}
          {TicketsRoutes()}
          {InvoiceRoutes()}
      
       
    </Route>
    <Route path="/auth" element={<Auth />}>
      <Route path="login" element={<AnotherLogin />} />
      <Route path="forget-password" element={<ChangePassword />} />
    </Route>
    {SettingRoutes()}

    <Route path="*" element={<PageNotFound />} />
    <Route path="page-not-found" element={<PageNotFound backbutton={false} />} />
  </Routes>
  );
}

export default Mainroutes;
